import React, { useState, useEffect } from "react";
import { getInitials } from "@/utils";
import { cn } from "@/lib/utils";

export interface AvatarProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src?: string | null;
  name?: string;
  alt?: string;
  className?: string;
  imageClassName?: string;
  fallbackClassName?: string;
  fallback?: React.ReactNode;
}

export function Avatar({
  src,
  name = "",
  alt,
  className,
  imageClassName,
  fallbackClassName,
  fallback,
  ...props
}: AvatarProps) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  const displayName = name || alt || "";

  if (src && !hasError) {
    return (
      <img
        src={src}
        alt={alt || displayName || "Avatar"}
        className={cn("object-cover", className, imageClassName)}
        onError={() => setHasError(true)}
        {...props}
      />
    );
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  return (
    <div
      className={cn(
        "bg-purple-100 dark:bg-purple-900/40 text-purple-600 dark:text-purple-300 flex items-center justify-center font-bold shrink-0",
        className,
        fallbackClassName
      )}
      title={displayName}
    >
      {getInitials(displayName)}
    </div>
  );
}

export const UserAvatar = Avatar;
export default Avatar;
